import {FC, useCallback, useContext, useEffect, useState} from 'react';
import {useRecoilValueLoadable} from 'recoil';

import Table from '@mui/material/Table';
import TableContainer from '@mui/material/TableContainer';
import {TableHeadContainer} from './TableHeadContainer';
import {TableToolbar} from './TableToolbar';
import {TableBodyContainer} from './TableBody/TableBodyContainer';
import {Paper, TablePagination} from '@mui/material';

import {EventBusContext} from '../../../../../providers/EventBus';

import {serviceRequestStatusesQuery} from '../../../../../store/service-requests/selectors';

interface IStatusHistory {
  serviceRequestId: number;
}

const StatusHistory: FC<IStatusHistory> = ({serviceRequestId}) => {
  const {contents, state} = useRecoilValueLoadable(serviceRequestStatusesQuery(serviceRequestId));
  const [page, setPage] = useState(0);
  const {bus} = useContext(EventBusContext);

  const handleChangePage = useCallback((event: unknown, newPage: number) => {
    setPage(newPage);
  }, []);

  useEffect(() => {
    if (state === 'hasError')
      bus?.emit('error', [
        contents,
        {
          toastId: 'statusHistory',
        },
      ]);

    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state]);

  return (
    <Paper sx={{flex: 1}}>
      <TableToolbar loadingState={state} />
      <TableContainer>
        <Table size="small">
          <TableHeadContainer />
          <TableBodyContainer
            statusHistory={Array.isArray(contents) ? contents.slice(page * 6, page * 6 + 6) : []}
            rowsPerPage={6}
            isLoading={state === 'loading'}
          />
        </Table>
        <TablePagination
          component="div"
          rowsPerPageOptions={[6]}
          count={state === 'hasValue' ? contents.length : 0}
          page={page}
          rowsPerPage={6}
          onPageChange={handleChangePage}
        />
      </TableContainer>
    </Paper>
  );
};

export default StatusHistory;
